import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { CombinedGraphQLErrors } from '@apollo/client/errors';

// Create error link to handle authentication failures
const errorLink = new ErrorLink(({ error }) => {
  if (CombinedGraphQLErrors.is(error)) {
    for (const err of error.errors) {
      if (err.message.startsWith('authentication failure: ')) {
        window.location.href = '/login';
        break;
      }
    }
  }
});

// Create HTTP link with hardcoded GraphQL endpoint
const httpLink = new HttpLink({
  uri: '/api/graphql',
  credentials: 'include', // This ensures cookies are sent with requests
});

// Create Apollo client
export const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});
